<template>
  <div id="BaseNotAuthenticatedPage">
    <BaseHeader
      :theme="theme"
      :should-show-nav-icons="false"
      :should-show-search-controls="false"
      :should-show-main-menu="false"
    />
    <div class="container">
      <div class="row">
        <div class="col">
          <not-authorized />
        </div>
      </div>
    </div>
    <BaseFooter
      :should-show-help-bar="true"
      :should-show-links="false"
    />
  </div>
</template>
<script>
  import BaseHeader from "@/components/Header/BaseHeader"
  import BaseFooter from "@/components/BaseFooter"
  import NotAuthorized from "@/components/Elements/NotAuthorized"

  export default {
    components: {
      BaseHeader,
      BaseFooter,
      NotAuthorized
    },
    props: {
      theme: {
        type: String,
        default: "Default"
      }
    }
  }

</script>
